import type { Page } from '../types';
import { withSBErrorHandling } from '../types';

import { ScanbotSDKPlugin } from './Definitions';

/**
 * @internal
 * @hidden
 */
export const ScanbotLegacyPageImpl = {
  async removePage(page: Page): Promise<void> {
    return withSBErrorHandling(() => ScanbotSDKPlugin.removeLegacyPage({ page: page }));
  },

  async removeAllPages(): Promise<void> {
    return withSBErrorHandling(() => ScanbotSDKPlugin.removeAllLegacyPages());
  },

  async setDocumentImage(params: { imageFileUri: string; page: Page }): Promise<Page> {
    return withSBErrorHandling(() => ScanbotSDKPlugin.setDocumentImageOnLegacyPage(params));
  },

  async refreshImageUris(pages: Page[]): Promise<Page[]> {
    return withSBErrorHandling(async () => {
      return (await ScanbotSDKPlugin.refreshImageUrisOnLegacyPage({ pages: pages })).result;
    });
  },
};
